module.exports = __webpack_public_path__ + "static/media/gallery_14_thumb.71decb08.jpg";